import './styles/tabs.less';
import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Layout, Tabs, Dropdown, Button, Menu } from 'antd';
import { router } from 'dva';
import NotFound from 'components/Pages/404';
const { Switch, Route, withRouter } = router;
const { Content } = Layout;
const TabPane = Tabs.TabPane;

function getTitle(pathName) {
  const map = window.dva_router_pathMap[pathName];
  return <div className="tab-title">{map ? map.title : 'Tag'}</div>;
}

@withRouter
export default class TabsLayout extends React.PureComponent {
  constructor(props) {
    const {
      location: { 
        pathname,
        search
      }
    } = props;
    super(props);
    console.log('constr location',location)
    this.state = this.setCurPanes(pathname,search, []);
  }
  
  componentDidUpdate(prevProps, prevState) {
    const pathname = prevProps.location.pathname;
    const search  = prevProps.location.search
    const nextpathname = this.props.location.pathname;
    const nextsearch = this.props.location.search;

    console.log('prev-path:',prevProps.location)
    console.log('next-path:',nextpathname,'-',nextsearch)

    if (pathname !== nextpathname) {
      const newState = this.setCurPanes(nextpathname,search);
      this.setState(newState);
    }
  }

  setCurPanes = (pathName, search ,_panes) => {
    const { childRoutes } = this.props;
    let panes = _panes || this.state.panes;
    const existPane = panes.some(item => item.key === pathName);
    if (existPane) {
      console.log('state:',pathName,'::',search,'::',panes)
      return {
        activeKey: pathName,
        panes,
        noMatch: false
      };
    } else {
      const nextPanes = childRoutes.filter(item => item.key === pathName);
      console.log('state:',pathName,search,panes)
      if (nextPanes.length) {
        return {
          activeKey: pathName,
          panes: panes.concat(nextPanes),
          noMatch: false
        };
      } else if (
        window.dva_router_pathMap[pathName] &&
        window.dva_router_pathMap[pathName].parentPath
      ) {
        // childRoutes中如果没有(分两种情况,确实没有,或可能是一个子路由在subChildRoute中)
        // 如果是子路由
        const parentPath = window.dva_router_pathMap[pathName].parentPath;
        return this.setCurPanes(parentPath, panes);
      } else {
        return {
          activeKey: pathName,
          panes: panes,
          noMatch: true
        };
      }
    }
  };

  onChange = (activeKey) => {
    console.log('tab change:',activeKey)
    this.props.history.push(activeKey);
  };

  onRemove = targetKey => {
    let { activeKey, search, panes } = this.state;
    let lastIndex;
    panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const newpanes = panes.filter(pane => pane.key !== targetKey);
    if (newpanes.length && activeKey === targetKey) {
      activeKey = lastIndex >= 0 ? newpanes[lastIndex].key : newpanes[0].key;
    }
    console.log('remove:',newpanes,search)
    this.setState({ panes: newpanes, activeKey, search:search }, () => {
      if (activeKey !== targetKey) this.onChange(activeKey);
    });
  };

  onRemoveOther = () => {
    let { activeKey, panes } = this.state;
    const newpanes = panes.filter(pane => pane.key === activeKey);
    this.setState({ panes: newpanes });
  };

  onRemoveAll = () => {
    this.setState({ panes: [], activeKey: null });
  };

  onTabsActions = ({ key }) => {
    let { activeKey } = this.state;
    switch (key) {
      case 'close':
        this.onRemove(activeKey);
        break;
      case 'closeother':
        this.onRemoveOther();
        break;
      case 'closeall':
        this.onRemoveAll();
        break;
      default:
        break;
    }
  };

  render() {
    const { panes, activeKey, search, noMatch } = this.state;

    return (
      <Layout className="full-layout tabs-layout">
        <Content>
          <Switch>
            {noMatch ? (
              <Route component={NotFound} />
            ) : (
              <Tabs
                hideAdd
                type="editable-card"
                className="lanif-tabs-content"
                tabBarExtraContent={
                  <Dropdown
                    overlay={
                      <Menu onClick={this.onTabsActions}>
                        <Menu.Item key="close">关闭当前</Menu.Item>
                        <Menu.Item key="closeother">关闭其它</Menu.Item>
                        <Menu.Item key="closeall">关闭所有</Menu.Item>
                      </Menu>
                    }
                  >
                    <Button type="primary" ghost>
                      操作
                      <DownOutlined />
                    </Button>
                  </Dropdown>
                }
                onEdit={this.onRemove}
                onChange={this.onChange}
                activeKey={activeKey}
                search={search}
              >
                {panes.map(item => (
                  <TabPane tab={getTitle(item.key)} key={item.key}>
                    {item}
                  </TabPane>
                ))}
              </Tabs>
            )}
          </Switch>
        </Content>
      </Layout>
    );
  }
}
